import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineParcelIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M7 14h2a1.0002 1.0002 0 0 0 .7071-1.7071A1.0002 1.0002 0 0 0 9 12H7a1.0002 1.0002 0 0 0-.7071 1.7071C6.4804 13.8946 6.7348 14 7 14Zm6 2H7a1.0002 1.0002 0 0 0-.7071 1.7071C6.4804 17.8946 6.7348 18 7 18h6a1.0001 1.0001 0 0 0 0-2Zm6-14H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3Zm-5 2v3.29l-1.51-.84a1 1 0 0 0-1 0L10 7.29V4h4Zm6 15a1.0001 1.0001 0 0 1-1 1H5a1.0002 1.0002 0 0 1-1-1V5a1 1 0 0 1 1-1h3v5a1 1 0 0 0 1.5.86L12 8.47l2.51 1.4A.9998.9998 0 0 0 15 10a1 1 0 0 0 1-1V4h3a1 1 0 0 1 1 1v14Z"/>
  </SvgIcon>
}

export default LineParcelIcon
